import React, { useEffect, useRef, useState } from "react";
import { useKeycloak } from "@react-keycloak/web";
import { useLocation } from "react-router-dom";
import Favicon from "react-favicon";
import { useDispatch, useSelector } from "react-redux";
/*import { useHistory } from "react-router-dom";*/

import "bootstrap/dist/css/bootstrap.css";
import "./App.css";
import i18n from "./i18n";
import { MULTITENANT_CONSTANTS, TENANT } from "./Resources/Multitenant/tenantConstants";
import {
  displayOnBoardingActionCreator,
  loadTenantStylesActionCreator,
  saveInterfaceUrlsActionCreator,
  saveSponsorsActionCreator,
  saveTenantLanguageActionCreator,
  saveUserDataActionCreator,
  saveLegalActionCreator,
  saveTenantRulesActionCreator,
  storeSectionsMenuActionCreator,
  saveInterfazIdActionCreator,
  saveCardFieldsActionCreator,
  saveTenantShowPreviews,
  saveTranslationsActionCreator,
  saveTutorialURLActionCreator,
  saveProfileMenuVisibleActionCreator,
  saveMenuDisplayActionCreator,
  savePlayerVersionActionCreator,
  userLoginActionCreator,
} from "./actions/commonActions";
import AnimationGetGoalComponent from "./Components/common/AnimationGetGoalComponent";
import {
  ANIMATION_GET_GOAL_ACHIEVEMENTS,
  ANIMATION_GET_GOAL_PLAY,
  ANIMATION_GET_GOAL_REWARDS,
  DEVICES,
  LOCAL_STORAGE_KEY__LOCALE,
  LOCAL_STORAGE_KEY__SKIP_ONBOARDING,
  MENU_DISPLAY_VALUES,
  MENU_DISPLAY_DEFAULT,
  PLAYER_VERSION_VALUES,
  PLAYER_VERSION_DEFAULT,
} from "./Utils/Constants";
import OnBoardingComponent from "./Components/common/OnBoarding/OnBoardingComponent";
import ModalAppsComponent from "./Components/common/ModalAppsComponent";
/*import { URL_LEGAL } from "./Components/Routes/Location";*/
import { getRewardsService, getTenantRules } from "./services/services";
import { getUserDataService, getMenu } from "./services/services";
import {
  getToken,
  setAchievementsAndRewardsInLocalStorage,
  setHtmlLang,
  getSectionUrl,
  removeTokenFromCookie,
} from "./Utils/utils";
import { applyTheme } from "./Utils/theme";
import { MENU_EXCLUDED_SECTIONS_BY_ID } from "./Pages/Menu/MenuConstants";
import { isCordovaAvailable } from "./Utils/secureStorageUtil";
import { initializeKeycloak, logoutFromKeycloak } from "./Utils/keycloak";
import { useRouteSeo } from "./Utils/usePageSeo";
import useSwipeBack from "./Utils/useSwipeBack";
import { detectImageTransparency } from "./Utils/Hooks/useLogoHasTransparency";
import history from "./Components/Routes/History";

const App = ({ children, setScrollRef }) => {
  const dispatch = useDispatch();
  /*const history = useHistory();*/
  const location = useLocation();
  const scrollRef = useRef();

  const { keycloak, initialized } = useKeycloak();

  const accessToken = getToken(keycloak);

  const DEVICE_WEB = "web"
  const DEVICE_ALL = "all";

  useEffect(() => {
    setScrollRef(scrollRef);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scrollRef]);

  const renderApp =
    useSelector((state) => state.commonState.onBoarding) || !MULTITENANT_CONSTANTS[TENANT]?.showOnBoarding;

  const handleDisplayOnBoarding = (value) => {
    dispatch(displayOnBoardingActionCreator(value));
  };

  const handleSkipOnBoarding = (value) => {
    localStorage.setItem(LOCAL_STORAGE_KEY__SKIP_ONBOARDING, JSON.stringify(value));
    handleDisplayOnBoarding(value);
  };

  const userData = useSelector((state) => state.commonState.userData);
  const userLogin = useSelector((state) => state.commonState.userLogin);
  const tenantStyles = useSelector((state) => state.commonState.tenantStyles);
  const storageLocale = localStorage.getItem(LOCAL_STORAGE_KEY__LOCALE) || MULTITENANT_CONSTANTS[TENANT]?.defaultLocale;

  useRouteSeo({ pathname: location?.pathname, tenantStyles });
  useSwipeBack();

  useEffect(() => {
    const handleMiniOpen = (e) => {
      e.preventDefault();
      history.push(e.detail.path);
    };
    document.addEventListener("mini-open", handleMiniOpen);
    return () => document.removeEventListener("mini-open", handleMiniOpen);
  }, []);

  const loadTenantStyles = (data) => {
    dispatch(loadTenantStylesActionCreator(data));
  };

  const [playingAnimationGetGoal, setPlayingAnimationGetGoal] = useState(false);
  const [achievementsState, setAchievementsState] = useState(null);
  const [rewardsState, setRewardsState] = useState(null);
  const [modalAppsMobile, setModalAppsMobile] = useState(false);
  const [device, setDevice] = useState(null);
  const [tenantLanguages, setTenantLanguages] = useState([]);
  /*const [currentLegalVersion, setCurrentLegalVersion] = useState(null);
  const [acceptedLegalVersion, setAcceptedLegalVersion] = useState(null);*/

  const openAnimationGetGoal = () => {
    setTimeout(() => {
      setPlayingAnimationGetGoal(true);
    }, 4000);
  };

  const closeAnimationGetGoal = () => {
    setPlayingAnimationGetGoal(false);
    localStorage.setItem(ANIMATION_GET_GOAL_PLAY, JSON.stringify(0));
    localStorage.setItem(ANIMATION_GET_GOAL_ACHIEVEMENTS, JSON.stringify({}));
    localStorage.setItem(ANIMATION_GET_GOAL_REWARDS, JSON.stringify({}));
    setAchievementsState("");
    setRewardsState("");
  };

  const getUserDataCallback = (response) => {
    /*setAcceptedLegalVersion(response.acceptedlegalversion);*/
    dispatch(saveUserDataActionCreator(response));
  };

  const getUserDataErrorCallback = async (error) => {
    if (isCordovaAvailable()) {
      dispatch(userLoginActionCreator(null));
      dispatch(saveUserDataActionCreator({username: null, role: null}));
      logoutFromKeycloak();
      await removeTokenFromCookie();
    }
  }

  /*useEffect(() => {
    if (acceptedLegalVersion !== null && acceptedLegalVersion !== undefined && currentLegalVersion !== null && currentLegalVersion !== undefined) {
      if (acceptedLegalVersion !== currentLegalVersion) {
        history.push(URL_LEGAL);
      }
    }
  }, [history, acceptedLegalVersion, currentLegalVersion]);*/

  const getMenuCallback = (response) => {
    const mainInterface = response;

    // Función para completar valores faltantes con fallbacks mientras no se implanten en todos los tenants
    // También se rellenan los idiomas ofrecidos (`languages`) sin entrada en `translations`, para que
    // el footer no oculte los enlaces legales en esos idiomas
    const fillMissingUrls = (translationsObject, fallbackPrivacy, fallbackTerms) => {
      const completed = {};
      const languages = new Set([...Object.keys(translationsObject), ...(mainInterface?.languages || [])]);
      languages.forEach(language => {
        completed[language] = {
          privacy_url: translationsObject[language]?.privacy_url || fallbackPrivacy,
          terms_conditions_url: translationsObject[language]?.terms_conditions_url || fallbackTerms
        };
      });
      return completed;
    };

    const translationsObject = {};
    if (mainInterface?.translations) {
      mainInterface.translations.forEach(translation => {
        if (translation.language) {
          translationsObject[translation.language] = {
            privacy_url: translation.privacy_url,
            terms_conditions_url: translation.terms_conditions_url
          };
        }
      });
    }

    const interfaceUrls = fillMissingUrls(
      translationsObject,
      mainInterface?.privacy_url,
      mainInterface?.terms_conditions_url
    );

    setTenantLanguages(mainInterface?.languages);
    /*setCurrentLegalVersion(mainInterface?.legal?.version);*/

    // TODO: almacenar toda la interface en el store directamente
    dispatch(saveLegalActionCreator(mainInterface.legal));
    dispatch(saveInterfaceUrlsActionCreator(interfaceUrls));
    dispatch(saveSponsorsActionCreator(mainInterface.sponsors));
    dispatch(saveTenantLanguageActionCreator(mainInterface.languages));
    dispatch(saveTenantShowPreviews(mainInterface.previews));
    dispatch(saveTranslationsActionCreator(mainInterface.translations));
    // Supuesto (OTT-1966 Fase 1): id de interfaz para el parámetro `interfaz=` de /buscar.
    dispatch(saveInterfazIdActionCreator(mainInterface.id));
    // OTT-1966: qué campos pinta la tarjeta de resultado en /buscar (comentario de Diego Dozo,
    // 2026-09-22). Llega siempre en la respuesta, pero se usa `?? null` (no `||`) para no pisar
    // una cadena vacía real ("solo título") con el valor por defecto de ResultCard.
    dispatch(saveCardFieldsActionCreator(mainInterface.card_fields ?? null));
    mainInterface?.tutorialUrl && dispatch(saveTutorialURLActionCreator(mainInterface.tutorialUrl));
    mainInterface?.legal && dispatch(saveLegalActionCreator(mainInterface.legal));

    const dataMenu = mainInterface.menu;

    // Detectar si existe un elemento con type "profile" en el menú
    const hasProfileMenu = dataMenu?.some(menu => menu.type === "profile") || false;
    dispatch(saveProfileMenuVisibleActionCreator(hasProfileMenu));

    const menuDisplayValue = MENU_DISPLAY_VALUES.includes(mainInterface?.menudisplay)
      ? mainInterface.menudisplay
      : MENU_DISPLAY_DEFAULT;
    dispatch(saveMenuDisplayActionCreator(menuDisplayValue));

    const playerVersionValue = PLAYER_VERSION_VALUES.includes(mainInterface?.playerversion)
      ? mainInterface.playerversion
      : PLAYER_VERSION_DEFAULT;
    dispatch(savePlayerVersionActionCreator(playerVersionValue));

    const mapMenuEntryToSection = (menuEntry) => {
      const { child, ...rest } = menuEntry;
      const sectionData = {
        ...rest,
        id: rest.name,
        iconId: rest.icon,
        screenId: rest.screen ?? null,
        type: rest.type ?? rest.name,
        order: rest.order ?? 9999,
      };

      return {
        section: sectionData,
        url: getSectionUrl(sectionData),
        children: (child || []).map(childMenu => mapMenuEntryToSection(childMenu)),
      };
    };

    if (!!dataMenu?.length) {
      const newDataMenu = dataMenu.filter(menu => {
        const { device } = menu;
        return device === DEVICE_ALL || device === DEVICE_WEB;
      }).map(menu => mapMenuEntryToSection(menu));
      newDataMenu.sort((a, b) => {
        const orderA = a.section.order;
        const orderB = b.section.order;
        return orderA - orderB;
      });

      const filteredSections = newDataMenu.filter((s) => {
        return !MENU_EXCLUDED_SECTIONS_BY_ID.includes(s?.section?.id?.toUpperCase());
      });

      dispatch(storeSectionsMenuActionCreator(filteredSections));
    }

    renderCssValues(mainInterface);
  };

  const getMenuErrorCallback = () => {
    dispatch(savePlayerVersionActionCreator(PLAYER_VERSION_DEFAULT));
  };

  useEffect(() => {
    if (keycloak?.authenticated) {
      const redirectUrl = localStorage.getItem("redirectAfterLogin");
      if (redirectUrl) {
        localStorage.removeItem("redirectAfterLogin");
        window.location.href = redirectUrl;
      }
    }
  }, [keycloak?.authenticated]);
  useEffect(() => {
    if ((!!keycloak && initialized) || isCordovaAvailable()) {
      const username = keycloak?.tokenParsed?.preferred_username ? keycloak?.tokenParsed?.preferred_username : userLogin;
      if (!!username) {

        getUserDataService(MULTITENANT_CONSTANTS[TENANT].tenantServer, username, accessToken, (r) =>
          getUserDataCallback(r), getUserDataErrorCallback
        );
      }
      getMenu(getMenuCallback, getMenuErrorCallback);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keycloak, initialized, userLogin]);

  useEffect(() => {
    if (!!accessToken && MULTITENANT_CONSTANTS[TENANT].gamification) {
      getUserRewards();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessToken]);

  const getFromLocalStorage = (field) => {
    return localStorage.getItem(field);
  };

  useEffect(() => {
    if (isCordovaAvailable()) {
      if (localStorage.getItem("access_token") && localStorage.getItem("refresh_token") && localStorage.getItem("username")) {
        initializeKeycloak(localStorage.getItem("access_token"), localStorage.getItem("refresh_token"), localStorage.getItem("username"));
      } else if (sessionStorage.getItem("access_token") && sessionStorage.getItem("refresh_token") && sessionStorage.getItem("username")) {
        initializeKeycloak(sessionStorage.getItem("access_token"), sessionStorage.getItem("refresh_token"), sessionStorage.getItem("username"));
      }
    }

    const activeAnimation = getFromLocalStorage(ANIMATION_GET_GOAL_PLAY);

    if (activeAnimation === "1") {
      const rewardsLocal = getFromLocalStorage(ANIMATION_GET_GOAL_REWARDS);
      !!rewardsLocal && setRewardsState(JSON.parse(rewardsLocal));
      const achievementLocal = getFromLocalStorage(ANIMATION_GET_GOAL_ACHIEVEMENTS);
      !!achievementLocal && setAchievementsState(JSON.parse(achievementLocal));
      openAnimationGetGoal();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderCssValues = (conf) => {
    applyTheme(conf);
    // Se analiza ya para que el menú lateral sepa si mostrar el logo en cuanto se abra
    detectImageTransparency(conf.logo);
  };

  /*const changeKeycloak = () => {
    //   setKeycloak(k);
  };*/

  /*const appLinksCallback = (res) => {
    //TODO: comprobar que las urls de las apps son válidas
    setAppUrlData(res);
  };*/

  /*useEffect(() => {
    getAppLinks(appLinksCallback);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);*/

  useEffect(() => {
    // Seleccionamos el idioma disponible:
    // 1- El del usuario si tenemos datos
    // 2- El idioma por defecto que nos viene en la petición de la interfaz general "MAIN" si el usuario no tiene datos
    // 3- El que almacenamos localmente por defecto en caso contrario a las condiciones anteriores
    if (((!!keycloak && !!initialized) || isCordovaAvailable()) || i18n.language) {
    const hasUserLanguage = !!userData && !!userData.language;
    const hasTenantLanguages = !!tenantLanguages && tenantLanguages.length > 0;

    if (hasUserLanguage) {
      i18n.changeLanguage(userData.language);
      localStorage.setItem(LOCAL_STORAGE_KEY__LOCALE, userData.language);
    } else if (hasTenantLanguages) {
      const defaultLang = tenantLanguages[0];
      i18n.changeLanguage(defaultLang);
      localStorage.setItem(LOCAL_STORAGE_KEY__LOCALE, defaultLang);
    } else {
      if (!storageLocale) {
        const defaultLocale = MULTITENANT_CONSTANTS[TENANT]?.defaultLocale;
        i18n.changeLanguage(defaultLocale);
        localStorage.setItem(LOCAL_STORAGE_KEY__LOCALE, defaultLocale);
      } else {
        i18n.changeLanguage(storageLocale);
      }
    }
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [userData, tenantLanguages]);

  /*const handleSplashOutput = (o) => {
    //TODO: ver cómo gestionar cuando el usuario tiene un nuevo logro/recompensa para mostrar la modal
    if (interops.getKotlinName(o) === "GameActionSent") {
      setAchievementsAndRewardsInLocalStorage(o);
    }
  };*/

  const rewardsCallback = (res) => {
    !!res &&
    setAchievementsAndRewardsInLocalStorage(res);
  };

  const getUserRewards = () => {
    const username = keycloak?.tokenParsed?.preferred_username;
    !!username && getRewardsService(TENANT, username, accessToken, rewardsCallback);
  };

  const isTenantFreeToPlay = (response) => {
    return !(!response.areAnonAllowed && response.hasMonetization);
  };

  const callbackTenant = (response) => {
    dispatch(saveTenantRulesActionCreator(response));
    const isFreeToPlay = isTenantFreeToPlay(response);
    loadTenantStyles({ ...MULTITENANT_CONSTANTS[TENANT], isFreeToPlay: isFreeToPlay });
  };

  useEffect(() => {
    const tenants = Object.keys(MULTITENANT_CONSTANTS);

    tenants.find((item) => item === TENANT)
      ? getTenantRules(callbackTenant)
      : loadTenantStyles(MULTITENANT_CONSTANTS.default);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (tenantStyles?.description) {
      let metaDescription = document.querySelector('meta[name="description"]');
      if (!metaDescription) {
        metaDescription = document.createElement('meta');
        metaDescription.name = "description";
        document.head.appendChild(metaDescription);
      }
      metaDescription.content = tenantStyles.description;
    }
    if (tenantStyles?.keywords) {
      let metaKeywords = document.querySelector('meta[name="keywords"]');
      if (!metaKeywords) {
        metaKeywords = document.createElement('meta');
        metaKeywords.name = "keywords";
        document.head.appendChild(metaKeywords);
      }
      metaKeywords.content = tenantStyles.keywords.join(', ');
    }
    if (tenantStyles?.canonical) {
      let linkCanonical = document.querySelector('link[rel="canonical"]');
      if (!linkCanonical) {
        linkCanonical = document.createElement('link');
        linkCanonical.rel = "canonical";
        document.head.appendChild(linkCanonical);
      }
      linkCanonical.href = tenantStyles.canonical;
    }
    if (tenantStyles?.favicon) {
      let linkFavicon = document.querySelector('link[rel="icon"]');
      if (!linkFavicon) {
        linkFavicon = document.createElement('link');
        linkFavicon.rel = "icon";
        linkFavicon.type = "image/x-icon";
        document.head.appendChild(linkFavicon);
      }
      linkFavicon.href = tenantStyles.favicon;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantStyles]);

  useEffect(() => {
    setHtmlLang(storageLocale);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storageLocale]);

  const toggleOpenModal = () => {
    setModalAppsMobile(!modalAppsMobile);
  };

  useEffect(() => {
    const platform = window.navigator.platform;

    for (const device of Object.keys(DEVICES)) {
      if (platform.includes(device)) {
        setDevice(DEVICES[device]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {!!tenantStyles?.favicon && <Favicon url={tenantStyles?.favicon} />}
      <>
        {renderApp !== false ? (
          <>
            <div ref={scrollRef} />
            {children}
          </>
        ) : (
          <OnBoardingComponent handleSkipOnBoarding={handleSkipOnBoarding} />
        )}
      </>
      {!!playingAnimationGetGoal && (
        <AnimationGetGoalComponent
          playingAnimationGetGoal={playingAnimationGetGoal}
          closeAnimationGetGoal={closeAnimationGetGoal}
          achievementsState={achievementsState}
          rewardsState={rewardsState}
        />
      )}
      {!!modalAppsMobile && !!device && (
        <ModalAppsComponent
          className={"classModalApps"}
          isOpen={true}
          toggleOpenModal={toggleOpenModal}
          content={"modal_apps_content"}
          title={"modal_apps_title"}
          subContent={"modal_apps_sub_content"}
          appUrlData={{}}
          device={device}
        />
      )}
    </>
  );
};

export default App;

